/*!

=========================================================
* Argon Dashboard React - v1.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// reactstrap components
import {
  Button,
  Card,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Row,
  Col,
} from "reactstrap";
import React, { useRef, useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import { toast } from "react-toastify";
import { AxiosResponse } from "axios";

import { PATHS } from "../../routes";
import { TypeForgotPassword } from "../../types";
import { forgotPassword } from "../../Services/UserAuth/UserAuthenticate";

const ForgotPassword = () => {

  const history = new useHistory();

  // we use the help of useRef to test if it's the first render
  const firstRender = useRef<boolean>(true);

  const user_Name = useRef<any>();
  let submit = useRef<any>();

  // set a state variable which can be used to disable the save/submit button
  const [disable, setDisabled] = useState<boolean>(true);

  //  set error messages to display to the user
  const [nameError, setNameError] = useState<string>("");

  // Rejex pattern
  // const pattern = new RegExp("^[^s@]+@([^s@.,]+.)+[^s@.,]{2,}$");
  const pattern = new RegExp(/^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/);

  const [isLoading, setIsLoading] = useState(false); // for submiting form
  const [userName, setUserName] = useState<string>("");
  // const [password, setPassword] = useState<string>("");

  useEffect(() => {
    // skip validation on first render
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }
    // here we can disable/enable the save button by wrapping the setState function
    // in a call to the validation function which returns true/false
    setDisabled(formValidation());
  }, [userName]);

  // here we run any validation, returning true/false
  const formValidation = () => {
    if (userName === "") {
      setNameError("Email can not be empty!");
      return true;
    } else if (!pattern.test(userName)) {
      setNameError("Email is not valid!");
      return true;
    } else {
      setNameError("");
      return false;
    }
  };

  const handleForgotPassword = (e) => {
    e.preventDefault();
    setIsLoading(true);

    let resetPasswordInfo: TypeForgotPassword = {
      email: userName,
      reset_url: 'http://192.168.238.141:3000/auth/reset-Password'
    };

    forgotPassword(resetPasswordInfo).then(
      (response: AxiosResponse) => {
        // console.log("Response Received: ", response.data);
        // history.push(PATHS.login);
        toast.success("Please check your email to reset password");
      }, (error) => {
        console.log("Error Caught: ", error?.response);
        if (error?.response?.status === 404) {
          toast.error("Email is not correct!");
        } else {
          toast.error("Can not send the mail! Please Try again!");
        }
      }
    ).catch((error) => console.log("Catched error ---> ", error)).finally(() => setIsLoading(false));
  };

  return (
    <React.Fragment>
      <Col lg="5" md="7">
        <Card className="bg-secondary shadow border-0">
          <CardBody className="px-lg-5 py-lg-5">
            <div className="text-center text-muted mb-4">
              <small>Enter email to receive link</small>
            </div>
            <Form role="form">
              <FormGroup className="mb-3">
                <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-email-83" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    type="email"
                    id="userEmial"
                    placeholder="Email"
                    autoComplete="new-email"
                    ref={user_Name}
                    required
                    autoFocus
                    onChange={(e) => {
                      setUserName(e.target.value);
                    }}
                  // onKeyDown={onKeyDownHandler}
                  />
                </InputGroup>
              </FormGroup>
              <div>
                {nameError && (
                  <p className="text-danger mt-0 rounded small">*{nameError}</p>
                )}
              </div>
              <div className="text-center">
                {
                  isLoading ? (<Button className="my-4" color="primary" size="block" type="button">
                    <div
                      className="spinner-border rounded-circle spinner-border-sm"
                      role="status">
                      <p className="sr-only">Loading...</p>
                    </div>
                  </Button>
                  ) : (
                    <Button className="my-4" color="primary" size="block"
                      type="button"
                      id="submitForm"
                      ref={submit}
                      disabled={disable}
                      onClick={(e) => handleForgotPassword(e)}>
                      Send Link <i className="fas fa-envelope pl-2"></i>
                    </Button>)
                }
              </div>
            </Form>
          </CardBody>
        </Card>
        {/* <Row className="mt-3">
          <Col xs="6">
            <a
                className="text-light"
                href="#pablo"
                onClick={(e) => { e.preventDefault(); history.push(PATHS.login) }}
              >
                <small>Go to login?</small>
              </a>
          </Col>
          <Col className="text-right text-light pointer" xs="6">
            <a
              onClick={(e) => { e.preventDefault(); history.push(PATHS.login) }}>
              <small>Go to login?</small>
            </a>
          </Col>
        </Row> */}
      </Col>
    </React.Fragment>
  );
};

export default ForgotPassword;
